import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFullOutScreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 8,
			fill: "black",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_23380_44913",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 6,
			y: 6,
			width: 5,
			height: 5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6 6H10.2553V10.6383H6V6Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_23380_44913)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M9.57832 6C9.2146 6 8.91916 6.29116 8.91916 6.6506V9.12391H6.65916C6.29499 9.12391 6 9.41507 6 9.77451V9.88375C6 10.2432 6.29499 10.5343 6.65916 10.5343H9.57832C9.94249 10.5343 10.2375 10.2432 10.2375 9.88375V6.65015C10.2375 6.29116 9.94249 6 9.57832 6Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_23380_44913",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 13,
			y: 6,
			width: 6,
			height: 5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.7461 6H18.0014V10.6383H13.7461V6Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_23380_44913)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M17.3471 9.12435H15.1022V6.6506C15.1022 6.29116 14.8093 6 14.4476 6C14.0859 6 13.793 6.29116 13.793 6.6506V9.88375C13.793 10.2432 14.0859 10.5343 14.4476 10.5343H17.3467C17.7084 10.5343 18.0013 10.2432 18.0013 9.88375V9.77451C18.0013 9.41551 17.7084 9.12435 17.3471 9.12435Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_23380_44913",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 6,
			y: 13,
			width: 5,
			height: 5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6 13.3594H10.2553V17.9977H6V13.3594Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask2_23380_44913)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M9.57832 13.4062H6.65916C6.29499 13.4062 6 13.7011 6 14.0651V14.1762C6 14.5397 6.29499 14.8346 6.65916 14.8346H8.91916V17.3393C8.91916 17.7033 9.2146 17.9982 9.57832 17.9982C9.94249 17.9982 10.2375 17.7033 10.2375 17.3393V14.0651C10.2375 13.7011 9.94249 13.4062 9.57832 13.4062Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask3_23380_44913",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 13,
			y: 13,
			width: 6,
			height: 5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.7461 13.3594H18.0014V17.9977H13.7461V13.3594Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask3_23380_44913)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M17.3471 13.4062H14.4476C14.0859 13.4062 13.793 13.7011 13.793 14.0651V17.3393C13.793 17.7033 14.0859 17.9982 14.4476 17.9982C14.8093 17.9982 15.1022 17.7033 15.1022 17.3393V14.8346H17.3471C17.7084 14.8346 18.0018 14.5397 18.0018 14.1762V14.0651C18.0013 13.7011 17.7084 13.4062 17.3471 13.4062Z",
				fill: "white"
			})
		})
	]
});
export default SvgFullOutScreen;
